export { default } from "./newsItem.api";

export * from "./newsItem.api.types";
